import React from 'react';
import BasketPageSection from "./BasketPageSection";
import styled from "styled-components";

interface QuantitySectionProps {
}

const Formulas = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;
  @media screen and (min-width: 576px) {grid-template-columns: 1fr 1fr;}
  @media screen and (min-width: 768px) {grid-template-columns: 1fr 1fr;}
  @media screen and (min-width: 992px) {grid-template-columns: 1fr 1fr 1fr;}
`;

const PackageCard = styled.div`
  background: white;
  border: 1px solid var(--orange-100);
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
`;

const InfoBox = styled.div`
  background: white;
  border: 1px solid var(--orange-100);
  border-left: 3px solid var(--orange);
  border-radius: 0.5rem;
  padding: 1.5rem;
`;


const QuantitySection = (props: QuantitySectionProps) => {
  return (
    <BasketPageSection image='pakketten-vrienden2.jpg' gradientPosition='left' title='Kies zelf'
                       subTitle='de hoeveelheid'>


      <p className="text-lg color-orange font-medium">Welk pakket past bij jou?</p>
      <p className="line-height-3 mb-4">Ben jij een echte groenteliefhebber, wil je nieuwe smaken ontdekken of gezonde
        gerechten op tafel zetten voor
        het hele gezin? Wij hebben voor iedereen een geschikt pakket.</p>
      <div className="gap-4 align-items-center">
        <Formulas className="gap-4 justify-content-center">
          <PackageCard>
            <div className="p-4">
              <div className='flex justify-content-between align-items-center mb-3'>
                <div className='color-green font-light text-2xl'>
                  <span className="font-bold text-4xl">Mini</span> pakket
                </div>
                <div className="color-orange text-base">
                  <span className="font-bold text-lg">4-5</span> groenten
                </div>
              </div>
              <div className='text-center text-md pt-2 font-medium line-height-3'>
                <span className="text-gray-600">+/- 4-5 maaltijden</span>
                <br/>
                <span className="font-medium text-xl">Voor <span className="font-bold">1 persoon</span></span>
              </div>
            </div>
            {/*<div className='flex justify-content-between mt-2 align-items-end p-2'>*/}
            {/*  <div>*/}
            {/*    <div className=''>*/}
            {/*      <span className="text-gray-500 text-xs">&plusmn;</span>*/}
            {/*      <span className="font-bold color-orange text-lg"> &euro; 11</span>*/}
            {/*      <span className="text-xs"> / week</span>*/}
            {/*    </div>*/}
            {/*    <div className=''>*/}
            {/*      <span className="text-gray-500 text-xs">&plusmn;</span>*/}
            {/*      <span className="font-medium color-orange text-md"> &euro; 435</span>*/}
            {/*      <span className="text-xs"> / jaar</span>*/}
            {/*    </div>*/}
            {/*  </div>*/}

            {/*  <a className="px-3 py-1 bg-orange text-white overflow-hidden md:text-lg uppercase border-round"*/}
            {/*     href="https://www.mijnboer.be/groentegeweld/inschrijven/pakketten?size=MINI">Schrijf me in</a>*/}
            {/*</div>*/}
          </PackageCard>

          <PackageCard>
            <div className="p-4">
              <div className='flex justify-content-between align-items-center mb-3'>
                <div className='color-green font-light text-2xl'>
                  <span className="font-bold text-4xl">Klein</span> pakket
                </div>
                <div className="color-orange text-base">
                  <span className="font-bold text-lg">5-7</span> groenten
                </div>
              </div>
              <div className='text-center text-md pt-2 font-medium line-height-3'>
                <span className="text-gray-600">+/- 4-5 maaltijden</span>
                <br/>
                <span className="font-medium text-xl">Voor <span className="font-bold">2 personen</span></span>
              </div>
            </div>
            {/*<div className='flex justify-content-between mt-2 align-items-end p-2'>*/}
            {/*  <div>*/}
            {/*    <div className=''>*/}
            {/*      <span className="text-gray-500 text-xs">&plusmn;</span>*/}
            {/*      <span className="font-bold color-orange text-lg"> &euro; 18</span>*/}
            {/*      <span className="text-xs"> / week</span>*/}
            {/*    </div>*/}
            {/*    <div className=''>*/}
            {/*      <span className="text-gray-500 text-xs">&plusmn;</span>*/}
            {/*      <span className="font-medium color-orange text-md"> &euro; 720</span>*/}
            {/*      <span className="text-xs"> / jaar</span>*/}
            {/*    </div>*/}
            {/*  </div>*/}

            {/*  <a className="px-3 py-1 bg-orange text-white overflow-hidden md:text-lg uppercase border-round"*/}
            {/*     href="https://www.mijnboer.be/groentegeweld/inschrijven/pakketten?size=STANDARD">Schrijf me in</a>*/}
            {/*</div>*/}
          </PackageCard>

          <PackageCard>
            <div className="p-4">
              <div className='flex justify-content-between align-items-center mb-3'>
                <div className='color-green font-light text-2xl'>
                  <span className="font-bold text-4xl">Groot</span> pakket
                </div>
                <div className="color-orange text-base">
                  <span className="font-bold text-lg">7-9</span> groenten
                </div>
              </div>
              <div className='text-center text-md pt-2 font-medium line-height-3'>
                <span className="text-gray-600">+/- 4-5 maaltijden</span>
                <br/>
                <span className="font-medium text-xl">Voor <span className="font-bold">je hele gezin</span></span>
              </div>
            </div>
            {/*<div className='flex justify-content-between mt-2 align-items-end p-2'>*/}
            {/*  <div>*/}
            {/*    <div className=''>*/}
            {/*      <span className="text-gray-500 text-xs">&plusmn;</span>*/}
            {/*      <span className="font-bold color-orange text-lg"> &euro; 26</span>*/}
            {/*      <span className="text-xs"> / week</span>*/}
            {/*    </div>*/}
            {/*    <div className=''>*/}
            {/*      <span className="text-gray-500 text-xs">&plusmn;</span>*/}
            {/*      <span className="font-medium color-orange text-md"> &euro; 1 040</span>*/}
            {/*      <span className="text-xs"> / jaar</span>*/}
            {/*    </div>*/}
            {/*  </div>*/}

            {/*  <a className="px-3 py-1 bg-orange text-white overflow-hidden md:text-lg uppercase border-round"*/}
            {/*     href="https://www.mijnboer.be/groentegeweld/inschrijven/pakketten?size=LARGE">Schrijf me in</a>*/}
            {/*</div>*/}
          </PackageCard>
        </Formulas>

        <InfoBox className="mt-4">
          <p className="text-lg font-medium color-orange mb-3">Vrienden op bezoek?</p>
          <p className="text-gray-600 line-height-3 mb-4">
            <span className="font-medium color-green">Vergroot eenvoudig je pakket</span>,
            zodat iedereen mee kan genieten van de heerlijke versheid in jouw gerechten.
          </p>

          <p className="text-lg font-medium color-orange mb-3">Of mag je zelf op bezoek?</p>
          <p className="text-gray-600 line-height-3 mb-0">
            <span className="font-medium color-green">Maak je pakket die week wat kleiner</span>, zodat je niets hoeft
            te verspillen.
          </p>
        </InfoBox>
      </div>


    </BasketPageSection>
  );
};

export default QuantitySection;
